import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/continuity.ts
const continuitySchema = z$1.strictObject({
	messagesSinceThen: z$1.number().int().finite().min(0),
	higherAuthorityUpdates: z$1.boolean()
});
//#endregion
export { continuitySchema };

//# sourceMappingURL=continuity.js.map